import { Layout, Select, Spin } from "antd";
import { Header } from "antd/es/layout/layout";
import { eventAutocompleteApi } from "api";
import { useEffect, useState } from "react";
import { useDebounce } from "use-debounce";
import { useQuery } from "react-query";
import useAdBlockStore from "store/AdBlockStore";

const EventSelector = () => {
  const [inputValue, setInputValue] = useState('');
  const [debouncedValue] = useDebounce(inputValue, 500);
  const events = useAdBlockStore(state => state.events);
  const sanitizedEvents = (events || []).filter(eventName => eventName && eventName.trim());

  useEffect(() => {
    if (!events) {
      return;
    }
    const needsNormalization = events.length !== sanitizedEvents.length ||
      events.some((eventName, index) => eventName !== sanitizedEvents[index]);

    if (needsNormalization) {
      useAdBlockStore.setState({ events: sanitizedEvents });
    }
  }, [events, sanitizedEvents]);

  const { data, isLoading } = useQuery(
    ['event-autocomplete', debouncedValue],
    () => eventAutocompleteApi(debouncedValue),
    {
      keepPreviousData: true,
      enabled: debouncedValue.length > 0,
    }
  );

  const apiOptions = (data?.results || [])
    .map(event => ({
      label: event.event_nm,
      value: event.event_nm, // Use event name as value, not ID
    }))
    .filter(option => option.value && option.value.trim());

  // Create options with selected items at the top
  const selectedOptions = sanitizedEvents.map(eventName => ({
    label: eventName,
    value: eventName,
  })) || [];

  // Filter out selected items from API results to avoid duplicates
  const unselectedOptions = apiOptions.filter(option => 
    !sanitizedEvents.includes(option.value)
  );

  // Combine selected items at top, then unselected items
  const options = [...selectedOptions, ...unselectedOptions];

  return (
      <Layout style={{ background: '#131313', borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
       }}>
        <Header
          style={{
            background: '#131313',
            color: '#909090',
            borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
            height: '38px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: '0 16px',
            fontSize: '12px',
            fontWeight: 'bold',
            letterSpacing: '0.25px',
            textTransform: 'uppercase',
          }}
        >
          Events
        </Header>
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          margin: '16px 0',
        }}>
          <Select
            showSearch
            placeholder='Select Events'
            mode='multiple'
            searchValue={inputValue}
            value={sanitizedEvents}
            maxTagCount={1}
            maxTagPlaceholder={(omittedValues) => `+${omittedValues.length}`}
            onChange={(value) => {
              const cleanedValues = (value || [])
                .map(eventName => eventName?.trim())
                .filter(eventName => eventName);
              useAdBlockStore.setState({ events: cleanedValues });
            }}
            onSearch={setInputValue}
            filterOption={false}
            notFoundContent={isLoading ? <Spin size="small" /> : null}
            options={options}
            style={{ width: '90%', maxHeight: '60px', overflow: 'auto' }}
            variant="filled"
            maxTagTextLength={8}
          />
        </div>
      </Layout>
  );
};

export default EventSelector;
